import React from 'react';

import { Table, Icon, Checkbox } from 'semantic-ui-react';

import { calculateBackgroundColor } from './helpers';
import { formatName } from '../../../utils/valueFormatter';

const CellWrapperForDepth = ({ item, children }) => {
  const { depth } = item;
  const hasChildren = item.childKeys && item.childKeys.length > 0;
  const cellStyle = {
    backgroundColor: calculateBackgroundColor(depth, hasChildren),
    color: hasChildren ? 'white' : 'black',
  };
  return (
    <Table.Cell style={cellStyle}>
      {children}
    </Table.Cell>
  );
};

export const GroupCell = ({ col, item, data }) => {
  const { depth } = item;
  const hasChildren = item.childKeys && item.childKeys.length > 0;
  const position = data.indexOf(item);
  const next = data[position + 1] || { key: '' };
  const hasOpenChildren = (next.key.includes(item.key) && next.depth > item.depth);

  return (
    <CellWrapperForDepth item={item}>
      <div style={{ marginLeft: depth * 16 }}>
        {hasChildren && (
          <Icon
            name={`chevron ${hasOpenChildren ? 'down' : 'right'}`}
            style={{ opacity: hasOpenChildren ? 0.5 : 1 }}
          />
        )}
        <span>{formatName(item[col.key])}</span>
      </div>
    </CellWrapperForDepth>
  );
};

export const CheckBoxCell = ({ col, item }) => {
  const hasChildren = item.childKeys && item.childKeys.length > 0;

  return (
    <CellWrapperForDepth item={item}>
      {!hasChildren && (
        <Checkbox
          checked={item[col.key] === item.count}
          disabled={col.disabled}
          onChange={(e, { checked }) => col.onClick(item, checked)}
        />
      )}
    </CellWrapperForDepth>
  );
};
